<template>
  <div class="cooperation mk-container">
    <Breadcrumbs />
    <div class="cooperation-container">
      <div class="muzik-markdown" v-html="compiledText">
        <!-- -->
      </div>
      <div class="cooperation-form">
        <div class="cooperation-form-item">
          <label for="company">
            {{ $t('COOPERATION.COMPANY') }}
          </label>
          <input id="company" v-model="userFormData.company" type="text">
        </div>
        <div class="cooperation-form-item">
          <label for="contact">
            {{ $t('COOPERATION.CONTACT') }}
          </label>
          <input id="contact" v-model="userFormData.contact" type="text">
        </div>
        <div class="cooperation-form-item">
          <label for="email">
            {{ $t('COOPERATION.EMAIL') }}
          </label>
          <input id="email" v-model="userFormData.email" type="text">
        </div>
        <div class="cooperation-form-item">
          <label for="phone">
            {{ $t('COOPERATION.PHONE') }}
          </label>
          <input id="phone" v-model="userFormData.phone" type="text">
        </div>
        <div class="cooperation-form-item">
          <label for="proposal">
            {{ $t('COOPERATION.PROPOSAL') }}
          </label>
          <textarea id="proposal" v-model="userFormData.proposal" name="proposal" type="text" rows="3" />
        </div>

        <div class="cooperation-form-panel">
          <button class="btn btn-submit" @click="submitForm">
            {{ $t('COOPERATION.SUBMIT') }}
          </button>
          <button class="btn btn-reset" @click="resetForm">
            {{ $t('COOPERATION.RESET') }}
          </button>
        </div>
      </div>
      <Paganiniplus />
    </div>
  </div>
</template>

<script>
import Paganiniplus from '@/components/tsp/Paganiniplus'
import Breadcrumbs from '@/components/common/Breadcrumbs'
export default {
  name: 'Cooperation',
  components: {
    Paganiniplus,
    Breadcrumbs
  },
  props: {},
  data() {
    return {
      compiledText: '',
      initFormData: {
        company: '',
        contact: '',
        email: '',
        phone: '',
        proposal: ''
      },
      userFormData: {}
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    title() {
      // const productionName = this.$production.toUpperCase()
      const productionLocaleName = this.$t(`${this.$production.toUpperCase()}.TITLE`)
      return `${this.$t('COOPERATION.TITLE')} | ${productionLocaleName} | MUZIK AIR`
    },
    description() {
      return this.$t('COOPERATION.TITLE')
    },
    cover() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const coverPath = this.$production.toLowerCase()
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
    },
    keywords() {
      return this.$t('COOPERATION.TITLE')
    },
    canonicalURL() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/cooperation`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/cooperation`
    },
    structuredData() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const urlSubDomain = isAirProduction ? '' : `${process.env[subDomainKey]}.`
      const structuredData = {
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        '@id': this.canonicalURL,
        url: this.canonicalURL,
        image: this.cover,
        name: this.title,
        description: this.title,
        relatedLink: [
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/terms`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/about`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/mediaKit`
        ]
      }
      return structuredData
    },
    locale() {
      // watch $i18n locale
      return this.$i18n.locale
    },
    getLocaleText() {
      return require('@/i18n/announcement/cooperation/' + this.locale + '.js')
    }
  },
  watch: {
    locale(newValue) {
      this.renderLocaleText()
    }
  },
  created() {},
  async mounted() {
    await this.dynamicLoadScript()
    /* eslint-disable no-undef */
    window.marked = marked
    this.renderLocaleText()
    this.resetForm()
  },
  methods: {
    async renderLocaleText() {
      if (window.marked) {
        this.compiledText = marked(this.getLocaleText, { sanitize: true })
      }
    },
    async dynamicLoadScript() {
      return new Promise((resolve, reject) => {
        let markedJS = document.createElement('script')
        // markedJS.setAttribute('type', 'text/javascript')
        // markedJS.setAttribute('src', 'https://cdn.jsdelivr.net/npm/marked/marked.min.js')
        markedJS.async = true
        markedJS.type = 'text/javascript'
        markedJS.src = 'https://cdn.jsdelivr.net/npm/marked/marked.min.js'
        document.head.appendChild(markedJS)
        markedJS.onload = () => {
          resolve()
        }
        markedJS.onerror = err => {
          reject(err)
        }
      })
    },
    resetForm() {
      this.userFormData = Object.assign({}, this.initFormData)
    },
    checkForm() {
      return true
    },
    async submitForm() {
      const check = await this.checkForm()
      if (!check) {
      } else {
        const emailServiceAddr = '' // service@muzik.com.tw
        const emailSubject = this.$t('COOPERATION.TITLE')
        const emailBody = `
          company: ${this.userFormData.company} \r\n
          contact: ${this.userFormData.contact} \r\n
          email: ${this.userFormData.email} \r\n
          phone: ${this.userFormData.phone} \r\n
          proposal: ${this.userFormData.proposal} \r\n `
        const encodedEmailBody = encodeURIComponent(emailBody)
        window.open(`mailto:${emailServiceAddr}?subject=${emailSubject}&body=${encodedEmailBody}`, '_self')
      }
    }
  }
}
</script>
<style lang="scss">
// No scoped for markdown diaplay
@import '@/assets/scss/variables.scss';
.cooperation {
  font-size: 16px;
  color: $grey-7d;
  &-container {
    margin: 24px 0;
  }
  &-form {
    margin: 60px 0;
    &-item {
      margin-bottom: 20px;
      label {
        display: block;
        font-size: 16px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.6;
        letter-spacing: normal;
        color: $grey-7d;
      }
      input {
        display: block;
        width: 100%;
        height: 42px;
        padding: 8px 16px;
        line-height: 26px;
        border-radius: 4px;
        background-color: white;
        border: solid 1px $grey-ec;
        color: #4a4a4a;
        font-weight: 700;
        font-size: 16px;
        outline: none;
        caret-color: $theme-yellow;
      }
      textarea {
        display: block;
        width: 100%;
        padding: 12px 16px;
        border-radius: 4px;
        background-color: white;
        border: solid 1px $grey-ec;
        outline: none;
        caret-color: $theme-yellow;
      }
    }

    .btn {
      display: inline-block;
      margin-right: 20px;
      &-submit {
        width: 190px;
        height: 48px;
        line-height: 48px;
        border-radius: 12px;
        border: solid 1px $theme-yellow;
        background-color: $theme-yellow;
        font-size: 20px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: normal;
        text-align: center;
        text-decoration: none;
        color: white;
        cursor: pointer;
        outline: none;

        &:hover {
          border: solid 1px $theme-yellow-hover;
          background-color: $theme-yellow-hover;
        }
        &:active {
          border: solid 1px $theme-yellow-active;
          background-color: $theme-yellow-active;
        }
        &:disabled {
          border: solid 1px $theme-yellow-disabled;
          background-color: $theme-yellow-disabled;
        }
      }
      &-reset {
        width: 190px;
        height: 48px;
        line-height: 48px;
        border-radius: 12px;
        background-color: white;
        border: solid 1px $grey-ec;

        font-size: 20px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: normal;
        text-align: center;
        color: $grey-9b;
        cursor: pointer;
        outline: none;

        &:hover {
          background-color: #faf6ef;
        }
        &:active {
          background-color: #f5efe5;
        }
        &:disabled {
          background-color: $grey-f3;
        }
      }
    }
  }
}
@media only screen and (min-width: 1440px) {
  .cooperation {
    &-container {
      max-width: 1024px;
      margin: 36px auto;
      // margin-top: 36px;
      // margin-bottom: 36px;
      // margin-left: calc(#{$padding-lg-grid-x2} - #{$padding-lg-grid-x1});
      // margin-right: calc(#{$padding-lg-grid-x2} - #{$padding-lg-grid-x1});
    }
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  .cooperation {
    &-container {
      margin-top: 24px;
      margin-bottom: 24px;
      margin-left: $padding-md-grid-x1;
      margin-right: $padding-md-grid-x1;
    }
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {
  .cooperation {
    .btn {
      width: 100%;
      margin-right: 0;
      margin: 20px 0;
    }
  }
}
</style>
